import type { MedicineSuggestion } from "@interfaces";
import { createCachedSearchService } from "./createCachedSearchService";

export const getProductsSuggestions = createCachedSearchService<MedicineSuggestion>(
  "mekidoc-products",
  "products suggestions",
);
